export const getStyle = (tagAlignment) => {
  return `
  <style>
    .main-wrapper {
      height: 400px;
      display: flex;
      gap: 20px;
      overflow: hidden;
      margin: 0 auto;
      max-width: 1342px;
      padding: 25px 48px 0;
    }
    .tag-image-list {
      position: absolute;
      bottom: 0;
      margin: 0;
      list-style: none;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 10px;
      ${tagAlignment === 'right' ? 'right: 0;' : ''}
    }
    .tag-image-list li {
      margin-bottom: 5px
    }
    .media-wrapper {
      width: 55%;
      overflow: hidden;
      border-radius: 12px;
      position: relative;
    }
    .slider-wrapper {
      width: 45%;
    }
    @media (max-width: 768px) {
      .main-wrapper {
        height: auto;
        flex-direction: column-reverse;
        overflow: auto;
        padding: 0;
      }
      .slider-wrapper {
        width: 100%;
        margin-top: 20px;
      }
      .tag-image {
        width: 48px;
      }
      .media-wrapper {
        width: 100%;
        height: 224px;
      }
      .tag-image-list {
        padding: 0 20px
      }
    }
  </style>
`;
};
